import { InjectionToken } from '@angular/core';
import { SupportConfig } from '../models/config/support-config.interface';

export const SUPPORT_CONFIG = new InjectionToken<SupportConfig>(
  'support config'
);
